module.exports = __webpack_public_path__ + "media/images/tmp/ig3-4fd09e9478054ca7733d4d347c590248.png";